import React from 'react';
// Browser tweaks
import { isEdge, isFirefox, isIE } from 'react-device-detect';
import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';
import { Auth0Provider } from '@auth0/auth0-react';
import { ThemeProvider } from '@mui/material/styles';
import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment';
import { addAccessTokenInterceptor } from 'api/interceptors';
import { withBouncer } from 'bouncer';

import Container from 'components/root/Container/Container';

// Stylesheets
import './images/icons/tick-arrow.png'; // Webpack required
import './images/icons/plus-icon.png'; // Webpack required
// TODO Workaround. Polyfill for ES6 Symbol https://www.npmjs.com/package/es6-symbol
import 'es6-symbol';

import { postLoginCallback } from './services/user-auth';
import muiTheme from './theme/mui-theme';
import { appInfo } from './root';
import store from './store';

import './index.scss';

if (isIE || isEdge || isFirefox) {
  import('./ie.css');
}

const root = createRoot(document.getElementById('root'));

const EntryComponent = getEntryComponent(appInfo);

root.render(
  <Provider store={store}>
    <LocalizationProvider dateAdapter={AdapterMoment} adapterLocale="en">
      <ThemeProvider theme={muiTheme}>
        <EntryComponent />
      </ThemeProvider>
    </LocalizationProvider>
  </Provider>
);

function getEntryComponent(appInfo = { features: {} }) {
  const { auth0ClientId, auth0IssuerUri, auth0Audience, auth0Connection, auth0LogoutUrl, profileName } = appInfo;

  if (profileName === 'e2e-test-authentication') {
    addAccessTokenInterceptor(() => localStorage.getItem('accessToken'));
    return props => (
      <Auth0Provider domain="" clientId="">
        <Container {...props} />
      </Auth0Provider>
    );
  }

  // We recieve auth0LogoutUrl from the appInfo api request and it looks like:
  //
  // https://intelligo.yadi.yada.amazoncognito.com/logout?redirect_uri=
  //
  // we need to assign the last part of the url query `redirect_uri` with the
  // origin of this app's url
  const fullLogoutUrl = `${auth0LogoutUrl}${window.location.origin}`;

  return withBouncer(
    Container,
    auth0ClientId,
    auth0Audience,
    auth0Connection,
    fullLogoutUrl,
    true,
    postLoginCallback,
    null,
    getAdditionalAuth0Props()
  );

  function getAdditionalAuth0Props() {
    if (auth0IssuerUri && typeof auth0IssuerUri === 'string') {
      const url = new URL(auth0IssuerUri);
      const domain = url?.hostname;
      if (domain) {
        return { domain };
      }
    }
    return null;
  }
}
